import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CouponService } from 'src/app/services/coupon.service';

@Component({
  selector: 'app-jaldee-offers',
  templateUrl: './jaldee-offers.component.html',
  styleUrls: ['./jaldee-offers.component.css']
})
export class JaldeeOffersComponent implements OnInit {
  api_error: any;
  statDetails:any = [];
  statTodayDetails:any = [];
  statLastWeekDetails:any = [];
  statTotalDetails:any = [];
  amount;
  todayAwarded: any;
  todayRedeemed: any;
  todayRefunded: any;
  todayExpired: any;
  lastWeekAwarded: any;
  lastWeekRedeemed: any;
  lastWeekRefunded: any;
  lastWeekExpired: any;
  totalAwarded: any;
  totalRedeemed: any;
  totalRefunded: any;
  totalExpired: any;
  filterParam: any;
  api_error1;
  customerData:any = {};
  offerData:any = {};
  spData:any = {};
  offerId: any;
  type: any;
  constructor( private couponService: CouponService,private activatedRoute: ActivatedRoute,private router: Router,private route: ActivatedRoute,) { }

  ngOnInit() {
    
    this.activatedRoute.queryParams.subscribe(params => {
      console.log(params);
      this.offerId = params.id;
      this.type = params.type;
      if(this.type === 'view'){
        this.getSpStat()
      }else{
        this.getOfferTodayStat();
        this.getOfferLastWeekStat();
        this.getOfferTotalStat();
      }
    });
  }
  getSpStat() {
  
    this.couponService.getOfferSpStat(this.offerId).subscribe(
      (data) => {
        this.statDetails = data;
        this.todayAwarded = this.statDetails[0].count;
        this.todayRedeemed = this.statDetails[1].count;
        this.todayRefunded = this.statDetails[2].count;
        this.todayExpired = this.statDetails[3].count;
        this.lastWeekAwarded = this.statDetails[4].count;
        this.lastWeekRedeemed = this.statDetails[5].count;
        this.lastWeekRefunded = this.statDetails[6].count;
        this.lastWeekExpired = this.statDetails[7].count;
        this.totalAwarded = this.statDetails[8].count;
        this.totalRedeemed = this.statDetails[9].count;
        this.totalRefunded = this.statDetails[10].count;
        this.totalExpired = this.statDetails[11].count;
      },
      (error) => {
        this.api_error = error.error;
      });
  }
  getOfferTodayStat() {
  
    this.couponService.getOfferTodayStat().subscribe(
      (data) => {
        this.statTodayDetails = data;
        this.todayAwarded = this.statTodayDetails[0].count;
        this.todayRedeemed = this.statTodayDetails[1].count;
        this.todayRefunded = this.statTodayDetails[2].count;
        this.todayExpired = this.statTodayDetails[3].count;
      },
      (error) => {
        this.api_error = error.error;
      });
  }
  getOfferLastWeekStat() {
  
    this.couponService.getOfferLastWeekStat().subscribe(
      (data) => {
        this.statLastWeekDetails = data;
        this.lastWeekAwarded = this.statLastWeekDetails[0].count;
        this.lastWeekRedeemed = this.statLastWeekDetails[1].count;
        this.lastWeekRefunded = this.statLastWeekDetails[2].count;
        this.lastWeekExpired = this.statLastWeekDetails[3].count;
      },
      (error) => {
        this.api_error = error.error;
      });
  }
  getOfferTotalStat() {
  
    this.couponService.getOfferTotalStat().subscribe(
      (data) => {
        this.statTotalDetails = data;
        this.totalAwarded = this.statTotalDetails[0].count;
        this.totalRedeemed = this.statTotalDetails[1].count;
        this.totalRefunded = this.statTotalDetails[2].count;
        this.totalExpired = this.statTotalDetails[3].count;
      },
      (error) => {
        this.api_error = error.error;
      });
  }
  getConsumers(JCashOfferStatType,OfferStatsDateCategory,_count) {
    // alert(JCashOfferStatType);
    // alert(OfferStatsDateCategory)
    const filterParam = 'consumer/statType/' + JCashOfferStatType + '/category/' + OfferStatsDateCategory;
    this.customerData.filterParam = filterParam;
    this.customerData.flag = true;
    this.customerData.count = _count;
      this.couponService.storeCustomererData(this.customerData);
    this.router.navigate(['../../customers/list'], { relativeTo: this.route });
  }
  getOffer(JCashOfferStatType,OfferStatsDateCategory,_count) {
    // alert(JCashOfferStatType);
    // alert(OfferStatsDateCategory)
    const filterParam = 'offer/statType/' + JCashOfferStatType + '/category/' + OfferStatsDateCategory;
    this.offerData.filterParam = filterParam;

    this.offerData.flag = true;
    this.offerData.count = _count;
      this.couponService.storeOfferDataData(this.offerData);
    this.router.navigate(['../../offers/cash/list'], { relativeTo: this.route });
  }
  getAccounts(JCashOfferStatType,OfferStatsDateCategory,_count) {
    const filterParam = 'sp/statType/' + JCashOfferStatType + '/category/' + OfferStatsDateCategory;
    this.spData.filterParam = filterParam;
    this.spData.flag = true;
    this.spData.count = _count;
    this.couponService.storeSpData(this.spData);
    this.router.navigate(['../../accounts/filter/list'], { relativeTo: this.route });

  }
}
